// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3453":"d444e6b0","4941":"d444e6b0","5769":"a7206454","7850":"55045a83","9992":"4e363773"}[chunkId] + ".chunk.css";
};